export default __webpack_public_path__ + "static/media/Tasty.b295223b.mp3";